<template>
    <div class="consumption-autonomy-card-component d-flex flex-column">
        <v-card color="grey lighten-5" elevation="0" rounded class="flex-1-1">
            <v-card-text class="d-flex flex-column" style="height: 100%">
                <div class="d-flex align-center gap-2 mb-3">
                    <v-icon class="font-color-light">mdi-clock-time-five-outline</v-icon>
                    <span class="font-color-light font-weight-bold">
                        {{ $t('consumption_report_widget_component.estimated_autonomy') }}
                    </span>
                </div>

                <div class="flex-1-1 d-flex flex-column justify-center">
                    <span class="font-color-light font-12 font-weight-bold">
                        {{ $t('consumption_report_widget_component.threshold_percent', [consumption.percent_0]) }}
                    </span>
                    <span class="font-16 font-color-normal">
                        {{ $t('consumption_report_widget_component.x_days', [consumption.day_before_threshold_0]) }}
                        ({{ moment(consumption.date_threshold_0).format(date_format) }})
                    </span>
                </div>
                <v-divider />

                <div class="flex-1-1 d-flex flex-column justify-center">
                    <span class="font-color-light font-12 font-weight-bold">
                        {{ $t('consumption_report_widget_component.threshold_percent', [consumption.percent_2]) }}
                    </span>
                    <span class="font-16 font-color-normal">
                        {{ $t('consumption_report_widget_component.x_days', [consumption.day_before_threshold_2]) }}
                        ({{ moment(consumption.date_threshold_2).format(date_format) }})
                    </span>
                </div>
                <v-divider />

                <div class="flex-1-1 d-flex flex-column justify-center">
                    <span class="font-color-light font-12 font-weight-bold">
                        {{ $t('consumption_report_widget_component.threshold_percent', [consumption.percent_1]) }}
                    </span>
                    <span class="font-16 font-color-normal">
                        {{ $t('consumption_report_widget_component.x_days', [consumption.day_before_threshold_1]) }}
                        ({{ moment(consumption.date_threshold_1).format(date_format) }})
                    </span>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import DisplayHuman from '@/mixin/displayHuman'

export default {
    name: 'ConsumptionAutonomyCardComponent',
    mixins: [DisplayHuman],
    props: {
        consumption: {
            type: Object,
            required: true,
        },
    },
}
</script>
